import { useState } from 'react';
import { useProtectedAction } from '../hooks/useProtectedAction';

const N8N = 'https://fatima.agenciafalei.com.br/webhook';
const TIPOS = [
  { id: 'clientes',      label: 'Clientes',      icon: '👥', desc: 'Cadastro de clientes' },
  { id: 'produtos',      label: 'Produtos',       icon: '📦', desc: 'Catálogo de produtos' },
  { id: 'servicos',      label: 'Serviços',       icon: '✂️', desc: 'Lista de serviços'   },
  { id: 'profissionais', label: 'Profissionais',  icon: '👤', desc: 'Cadastro de profissionais' },
];

// Decodifica o base64 vindo do n8n e dispara o download do .xlsx
function baixarBase64(base64, nome) {
  const bin = atob(base64);
  const bytes = new Uint8Array(bin.length);
  for (let i = 0; i < bin.length; i++) bytes[i] = bin.charCodeAt(i);
  const blob = new Blob([bytes], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = nome || 'migracao.xlsx';
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(() => URL.revokeObjectURL(url), 1500);
}

export default function Migrador() {
  const [tipo, setTipo]       = useState('clientes');
  const [idSalao, setIdSalao] = useState('');
  const [arquivo, setArquivo] = useState(null);
  const [dados, setDados]     = useState(null);
  const [loading, setLoading] = useState(false);
  const [status, setStatus]   = useState('');
  const [resultado, setResultado] = useState(null);

  const { protect, Modals, logado, temPlano } = useProtectedAction(true);
  const bloqueado = !logado || !temPlano;

  const handleFile = (e) => {
    const f = e.target.files[0];
    if (!f) return;
    setArquivo(f); setResultado(null);
    setStatus('✅ ' + f.name + ' selecionado');
    setDados({ file: f });
  };

  const migrar = protect(async () => {
    if (!dados?.file) { setStatus('⚠ Selecione um arquivo.'); return; }
    setLoading(true); setStatus(''); setResultado(null);
    try {
      const formData = new FormData();
      formData.append('file', dados.file);
      formData.append('tipo', tipo);
      formData.append('campoExtra', idSalao);
      const r = await fetch(`${N8N}/migravip-converter`, { method: 'POST', body: formData });
      const data = await r.json();
      // FIX: o n8n responde { sucesso, arquivo, nome, total } — não { ok }
      if (!data.sucesso) throw new Error(data.erro || data.message || 'Erro na conversão');
      if (!data.arquivo) throw new Error('Resposta sem arquivo (campo "arquivo" vazio).');
      // FIX: efetivamente baixa o xlsx que o n8n devolveu em base64
      baixarBase64(data.arquivo, data.nome);
      setResultado(data);
      setStatus('✅ ' + (data.total || '') + ' registros convertidos! Download iniciado.');
    } catch(e) { setStatus('⚠ ' + e.message); }
    finally { setLoading(false); }
  });

  return (
    <div style={{ maxWidth: '800px', margin: '0 auto' }}>
      {Modals}
      <div style={{ marginBottom: '28px' }}>
        <h1 style={{ fontFamily: 'Syne, sans-serif', fontSize: '26px', fontWeight: '800', letterSpacing: '-0.5px', marginBottom: '6px' }}>Migrador de Planilhas</h1>
        <p style={{ color: '#52526e', fontSize: '13px' }}>Converta planilhas para o formato Avec via IA.</p>
      </div>
      <div style={card}>
        <div style={{ marginBottom: '20px' }}>
          <label style={lbl}>Tipo de migração</label>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4,1fr)', gap: '8px', marginTop: '6px' }}>
            {TIPOS.map(t => (
              <button key={t.id} onClick={() => setTipo(t.id)} style={{
                padding: '14px 8px', borderRadius: '10px', cursor: 'pointer', textAlign: 'center',
                border: tipo===t.id ? '2px solid #6c47ff' : '1.5px solid rgba(0,0,0,0.1)',
                background: tipo===t.id ? 'rgba(108,71,255,0.07)' : '#f8f8fc'
              }}>
                <div style={{ fontSize: '22px', marginBottom: '6px' }}>{t.icon}</div>
                <div style={{ fontFamily: 'Syne, sans-serif', fontSize: '12px', fontWeight: '700', color: tipo===t.id ? '#6c47ff' : '#0a0a18' }}>{t.label}</div>
              </button>
            ))}
          </div>
        </div>
        <div style={{ marginBottom: '20px' }}>
          <label style={lbl}>ID do salão <span style={{ opacity:.5 }}>(opcional)</span></label>
          <input value={idSalao} onChange={e=>setIdSalao(e.target.value)} placeholder="Ex: 125411" style={inp} />
        </div>
        <div style={{ marginBottom: '20px' }}>
          <label style={lbl}>Arquivo</label>
          <div onClick={() => document.getElementById('migr-file').click()}
            style={{ border: '2px dashed rgba(108,71,255,0.3)', borderRadius: '12px', padding: '28px',
              textAlign: 'center', cursor: 'pointer', background: arquivo ? 'rgba(108,71,255,0.04)' : '#f8f8fc' }}>
            <div style={{ fontSize: '28px', marginBottom: '8px' }}>{arquivo ? '📄' : '📁'}</div>
            <div style={{ fontFamily: 'Syne, sans-serif', fontWeight: '700', fontSize: '14px', marginBottom: '4px' }}>
              {arquivo ? arquivo.name : 'Clique para selecionar'}
            </div>
            <div style={{ fontSize: '12px', color: '#9898b8' }}>{arquivo ? ((arquivo.size/1024).toFixed(1) + ' KB') : 'Suporta .xlsx, .xls, .csv'}</div>
            <input id="migr-file" type="file" accept=".xlsx,.xls,.csv" hidden onChange={handleFile} />
          </div>
        </div>

        {bloqueado && (
          <div style={{ background: 'rgba(108,71,255,0.06)', border: '1px solid rgba(108,71,255,0.2)',
            borderRadius: '10px', padding: '12px 16px', marginBottom: '16px', fontSize: '13px', color: '#6c47ff' }}>
            {!logado ? '🔒 Entre para usar o migrador' : '🔒 Faça seu plano para converter planilhas'}
          </div>
        )}

        {status && (
          <div style={{ padding: '10px 14px', borderRadius: '9px', marginBottom: '14px', fontSize: '12px', fontFamily: 'monospace',
            background: status.startsWith('✅') ? 'rgba(16,185,129,0.08)' : 'rgba(239,68,68,0.08)',
            color: status.startsWith('✅') ? '#059669' : '#dc2626',
            border: '1px solid ' + (status.startsWith('✅') ? 'rgba(16,185,129,0.2)' : 'rgba(239,68,68,0.2)') }}>{status}</div>
        )}

        {/* Avisos e de-para do que a IA mapeou — evita entregar planilha com coluna vazia sem ninguém perceber */}
        {resultado?.mapeamento?.length > 0 && (
          <div style={{ background: '#f8f8fc', border: '1px solid rgba(0,0,0,0.08)', borderRadius: '10px',
            padding: '12px 16px', marginBottom: '16px' }}>
            <div style={{ fontSize: '11px', fontWeight: '700', color: '#52526e', textTransform: 'uppercase',
              letterSpacing: '0.06em', fontFamily: 'monospace', marginBottom: '8px' }}>Colunas mapeadas</div>
            <div style={{ fontSize: '12px', color: '#52526e', fontFamily: 'monospace', lineHeight: '1.7' }}>
              {resultado.mapeamento.map((m, i) => <div key={i}>{m}</div>)}
            </div>
          </div>
        )}

        {resultado?.avisos?.length > 0 && (
          <div style={{ background: 'rgba(245,158,11,0.07)', border: '1px solid rgba(245,158,11,0.25)',
            borderRadius: '10px', padding: '12px 16px', marginBottom: '16px', fontSize: '13px', color: '#b45309' }}>
            {resultado.avisos.map((a, i) => <div key={i} style={{ marginBottom: '4px' }}>⚠ {a}</div>)}
          </div>
        )}

        {/* Botão de re-download caso o navegador bloqueie o download automático */}
        {resultado?.arquivo && (
          <div style={{ background: 'rgba(16,185,129,0.06)', border: '1px solid rgba(16,185,129,0.2)',
            borderRadius: '10px', padding: '12px 16px', marginBottom: '16px',
            display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '12px' }}>
            <div style={{ fontSize: '13px', color: '#059669' }}>
              📄 {resultado.nome} · {resultado.total} registros
            </div>
            <button onClick={() => baixarBase64(resultado.arquivo, resultado.nome)} style={{
              background: '#059669', color: '#fff', border: 'none', borderRadius: '8px',
              padding: '8px 16px', fontSize: '13px', fontWeight: '600', cursor: 'pointer', whiteSpace: 'nowrap' }}>
              ↓ Baixar de novo
            </button>
          </div>
        )}

        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <button onClick={migrar} disabled={loading || !dados} style={{
            background: loading || !dados ? '#9898b8' : 'linear-gradient(135deg, #6c47ff, #5535e0)',
            color: '#fff', border: 'none', borderRadius: '10px',
            padding: '11px 28px', fontSize: '14px', fontWeight: '600', cursor: loading || !dados ? 'not-allowed' : 'pointer'
          }}>
            {loading ? 'Convertendo...' : bloqueado ? '🔒 ' + (!logado ? 'Entrar' : 'Ver planos') : 'Converter →'}
          </button>
        </div>
      </div>
    </div>
  );
}

const card = { background: '#fff', border: '1px solid rgba(0,0,0,0.08)', borderRadius: '14px', padding: '24px', boxShadow: '0 1px 3px rgba(0,0,0,0.05)' };
const lbl = { fontSize: '11px', fontWeight: '700', color: '#52526e', textTransform: 'uppercase', letterSpacing: '0.06em', fontFamily: 'monospace', display: 'block', marginBottom: '6px' };
const inp = { width: '100%', padding: '10px 12px', borderRadius: '9px', border: '1.5px solid rgba(0,0,0,0.1)', fontSize: '14px', background: '#f8f8fc', outline: 'none', boxSizing: 'border-box', fontFamily: 'DM Sans, sans-serif', color: '#0a0a18' };
